export default "__VITE_ASSET__C63K7Pxp__"